// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2-BN7","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2H2A1"};